const DEFAULT_STATE: IUserMenuState = {
	iirisLogoutButtonId: 'irisLogoutBtn'
};
interface IUserMenuState {
	iirisLogoutButtonId: string;
}
export const UserMenuState = {
	...DEFAULT_STATE
};
